import React from 'react';
import CwPodGridColumn from './CwPodGridColumn';

const cwPodGridLoader = (props) => {
  // extract required props
  const {maxColumns, children, customLayout} = props;

  if(customLayout) {
    // Return the custom defined layout
    return children;
  }

  const podColumns = [];

  // By default, add all pods to first column
  podColumns.push(<CwPodGridColumn key={0}>{children}</CwPodGridColumn>);

  // build rest of empty pod columns
  for (let i = 1; i < maxColumns; i++) {
    podColumns.push(<CwPodGridColumn key={i}/>);
  }

  return podColumns;
};

export default cwPodGridLoader;


// WEBPACK FOOTER //
// ./src/components/cwpodgrid/CwPodGridLoader.js